<template>
  <article class="m-card-element m-card-element-design-5 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <AtomListElementActionsSecondary
        v-if="!hideMoveIcon"
        :element="element"
      />
      <AtomListElementActionsPrimary
        :element="element"
      />

      <div
        v-if="showSelected && parseInt($route.params.subid) === 5"
        class="m-card-element-info-data-selected"
      >
        {{ $t('mFeedSectionContentCardDesing5.selected') }}
      </div>

      <h5
        v-if="element.categoria"
        key="categoryName"
      >
        {{ productoCategoriaNombre }}
      </h5>
      <h5
        v-else
        key="noCategoryName"
      >
        {{ $t('mFeedSectionContentCardDesing5.noCategoryName') }}
      </h5>

      <h2 class="m-card-element-design-5-name">
        {{ element.nombre }}
      </h2>

      <div class="m-card-element-design-5-assets-included">
        <div
          v-for="i in 4"
          :key="`img${i}`"
        >
          <img
            v-if="tarjeta.metadata[`imagen${i}`]"
            :alt="element.nombre"
            :id="`cardImg-${i}`"
            :src="tarjeta.metadata[`imagen${i}`]"
          >
          <img
            v-else
            :alt="element.nombre"
            :id="`cardImg-${i}`"
            src="@/assets/img/ds5.png"
          >
        </div>
      </div>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.activo"
          key="available"
        >
         {{ $t('mFeedSectionContentCardDesing5.available') }}
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          {{ $t('mFeedSectionContentCardDesing5.notAvailable') }}
        </h3>
        <h4
          v-if="element.visible"
          key="visible"
        >
          {{ $t('mFeedSectionContentCardDesing5.visible') }}
        </h4>
        <h4
          v-else
          key="hidden"
        >
          {{ $t('mFeedSectionContentCardDesing5.hidden') }}
        </h4>
      </div>
      <router-link
        class="m-card-element-info-state-of-price"
        :to="`/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
      >
        {{ productoPrecio }}
      </router-link>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign5',

  props: {
    element: Object,
    elementCategorias: Array,
    hideMoveIcon: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tarjeta: {
        tipo: 5,
        metadata: {
          imagen1: '',
          imagen2: '',
          imagen3: '',
          imagen4: ''
        }
      }
    }
  },

  computed: {
    productoCategoriaNombre () {
      return this.element.categoria.nombre !== undefined
        ? this.element.categoria.nombre
        : this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.categoria.id_producto_categoria).nombre
    },

    productoPrecio () {
      return this.element.pago ? this.$t('mFeedSectionContentCardDesing5.price.buy') : this.$t('mFeedSectionContentCardDesing5.price.free')
    }
  },

  created () {
    if (this.element.tarjeta && this.element.tarjeta === 5) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta, metadata: Object.assign({}, this.element.metadata) })
    }
  }
}
</script>
